import { render, staticRenderFns } from "./IssuedCertificates.vue?vue&type=template&id=3548fe6b&scoped=true&"
import script from "./IssuedCertificates.vue?vue&type=script&lang=js&"
export * from "./IssuedCertificates.vue?vue&type=script&lang=js&"
import style0 from "./IssuedCertificates.vue?vue&type=style&index=0&id=3548fe6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3548fe6b",
  null
  
)

export default component.exports